import type { Options } from 'ky'
import type {
  GetListAddOnsResponse,
  PatchAddOnsResponse,
  PostGetSelectedAddOnsResponse,
} from '@/types/add-ons'
import type {
  PatchAddOnsHourlyPayload,
  PatchAddOnsPointToPointsPayload,
  PostGetSelectedAddOnsPayload,
} from '@/schemas/add-ons'
import { httpClient } from '@/utils/http'

export const addOnsService = {
  getList: (options?: Options) =>
    httpClient.get('add_ons', options).json<GetListAddOnsResponse>(),
  patchPointToPoints: ({
    id,
    ...payload
  }: PatchAddOnsPointToPointsPayload & {
    id: string
  }) => {
    return httpClient
      .patch(`add_ons/update/${id}`, {
        json: payload,
      })
      .json<PatchAddOnsResponse>()
  },
  patchHourly: ({
    id,
    hourly_id,
    ...payload
  }: PatchAddOnsHourlyPayload & {
    id: string
    hourly_id: string
  }) =>
    httpClient
      .patch(`add_ons/update/${id}/hourly/${hourly_id}`, {
        json: payload,
      })
      .json<PatchAddOnsResponse>(),
  getSelectedAddOns: ({
    id,
    ...payload
  }: PostGetSelectedAddOnsPayload & {
    id: string
  }) =>
    httpClient
      .post(`add_ons/selected/${id}`, {
        json: payload,
      })
      .json<PostGetSelectedAddOnsResponse>(),
}
